import React, { useEffect, useState, useRef } from 'react'

export const useApexResizeObserver = () => {
  const ref = useRef(null)

  useEffect(() => {
    if (!ref.current) return

    const ro = new ResizeObserver(() => {
      window.dispatchEvent(new Event('resize'))
    })

    ro.observe(ref.current)
    return () => ro.disconnect()
  }, [])

  return ref
}
